import React, { useState } from "react";
import { IoIosSwitch } from "react-icons/io";
import { useSelector } from "react-redux";

const OverlayTemplatesModal = ({
  setShowOverlayModal,
  handleEffectSetting,
}) => {
  const [showPreview, setShowPreview] = useState("name_animation.png");
  const overlayData = useSelector(
    (state) => state.personalize.personalize_overlayTemplateData
  );

  const handleClick = (e, type, animationType) => {
    handleEffectSetting(e, type, animationType);
    setShowOverlayModal(false);
  };

  const handleOver = (e, type) => {
    if (type === "name_animation") {
      setShowPreview(type + ".png");
    } else {
      setShowPreview(type + ".png");
    }
  };

  return (
    <div
      className="modal fade show d-block"
      id="modalcreatevideo"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="modalcreatevideoTitle"
      aria-hidden="true"
    >
      <div
        className="modal-dialog modal-dialog-centered modal-xl"
        role="document"
      >
        <div className="modal-content">
          <div className="modal-header">
            <h3>Overlay Templates</h3>
            <button
              type="button"
              className="close"
              onClick={() => {
                setShowOverlayModal(false);
              }}
            >
              <i
                className="fas fa-times"
                style={{ fontSize: "20px", color: "#cacccf" }}
              ></i>
            </button>
          </div>
          <div className="modal-body">
            <div className="row">
              <div className="col-5">
                <div className="list-container p-4">
                  <div className="list-group">
                    <div className="accordion" id="accordionExample">
                      <div className="accordion-item border-0">
                        <h2 className="accordion-header" id="headingOne">
                          <button
                            className={`list-group-item list-group-item-action border-0 h5 mb-0 ${
                              overlayData.some(
                                (element) => element.type === "name_animation"
                              )
                                ? "action-added"
                                : ""
                            }`}
                            disabled={overlayData.some(
                              (element) => element.type === "name_animation"
                            )}
                            onMouseOver={(e) => handleOver(e, "name_animation")}
                            onClick={(e) => handleClick(e, "name_animation")}
                          >
                            <IoIosSwitch size={24} className="text-info" />{" "}
                            Name Animation
                          </button>
                        </h2>
                      </div>
                    </div>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "text_animation_1"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "text_animation_1"
                      )}
                      onClick={(e) => handleClick(e, "text_animation_1")}
                      onMouseOver={(e) => handleOver(e, "text_animation_1")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Simple
                      Text Animation 1
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "text_animation_2"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "text_animation_2"
                      )}
                      onClick={(e) => handleClick(e, "text_animation_2")}
                      onMouseOver={(e) => handleOver(e, "text_animation_2")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Simple
                      Text Animation 2
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "simple_reveal"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "simple_reveal"
                      )}
                      onClick={(e) => handleClick(e, "simple_reveal")}
                      onMouseOver={(e) => handleOver(e, "simple_reveal")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Simple
                      Reveal Effect
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "speech_bubble"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "speech_bubble"
                      )}
                      onClick={(e) => handleClick(e, "speech_bubble")}
                      onMouseOver={(e) => handleOver(e, "speech_bubble")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Speech
                      Bubble 1
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "speech_bubble_2"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "speech_bubble_2"
                      )}
                      onClick={(e) => handleClick(e, "speech_bubble_2")}
                      onMouseOver={(e) => handleOver(e, "speech_bubble_2")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Speech
                      Bubble 2
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "speech_bubble_3"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "speech_bubble_3"
                      )}
                      onClick={(e) => handleClick(e, "speech_bubble_3")}
                      onMouseOver={(e) => handleOver(e, "speech_bubble_3")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Speech
                      Bubble 3
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "speech_thought"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "speech_thought"
                      )}
                      onClick={(e) => handleClick(e, "speech_thought")}
                      onMouseOver={(e) => handleOver(e, "speech_thought")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Speech
                      Bubble Thought
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "border_animation"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "border_animation"
                      )}
                      onClick={(e) => handleClick(e, "border_animation")}
                      onMouseOver={(e) => handleOver(e, "border_animation")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Border
                      Animation 1
                    </button>
                    <button
                      className={`list-group-item list-group-item-action border-0 h5 ${
                        overlayData.some(
                          (element) => element.type === "border_animation_2"
                        )
                          ? "action-added"
                          : ""
                      }`}
                      disabled={overlayData.some(
                        (element) => element.type === "border_animation_2"
                      )}
                      onClick={(e) => handleClick(e, "border_animation_2")}
                      onMouseOver={(e) => handleOver(e, "border_animation_2")}
                    >
                      <IoIosSwitch size={24} className="text-info" /> Border
                      Animation 2
                    </button>
                  </div>
                </div>
              </div>
              <div className="col-7">
                <div className="display-container bg-light">
                  <div className="preview-template col-8 m-auto p-4">
                    <img
                      src={
                        "https://engageleads-gallery.s3.us-west-2.amazonaws.com/VidAmaze/overlay_preview/" +
                        showPreview
                      }
                      className="img-fluid img-thumbnail mx-auto"
                      alt={`Preview ${showPreview}`}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OverlayTemplatesModal;
